import {
  PRODUCT_MENU_LOAD_FILTERS,
  PRODUCT_MENU_SET_FILTER,
  PRODUCT_MENU_SET_SUB_FILTER,
  PRODUCT_MENU_SET_COLOR,
  PRODUCT_MENU_SET_SELECTABLE_COLORS,
  PRODUCT_MENU_CLEAR_FILTER,
  PRODUCT_MENU_SET_SUB_FILTER_OPTIONS,
} from '../actionConstants';
import defaultState from './productMenuDefaultState';
import { Action } from '../../generalTypes';
import { ProductMenu } from './productMenuTypes';

export default (state: ProductMenu = defaultState, action: Action<any>) => {
  switch (action.type) {
    case PRODUCT_MENU_SET_SUB_FILTER:
      return {
        ...state,
        swiper: { ...state.swiper, currentSubFilter: action.payload },
      };

    case PRODUCT_MENU_SET_COLOR:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.filterName]: {
            ...state.filters[action.payload.filterName],
            currentColorFilter: action.payload.color,
          },
        },
      };

    case PRODUCT_MENU_LOAD_FILTERS:
      return {
        ...state,
        filters: action.payload.filters,
      };

    case PRODUCT_MENU_SET_SELECTABLE_COLORS: {
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.filterName]: {
            ...state.filters[action.payload.filterName],
            selectableColors: action.payload.selectableColors,
          },
        },
      };
    }

    case PRODUCT_MENU_SET_FILTER: {
      return {
        ...state,
        swiper: {
          ...state.swiper,
          currentFilter: action.payload,
        },
      };
    }

    case PRODUCT_MENU_CLEAR_FILTER: {
      return {
        ...state,
        swiper: {
          ...state.swiper,
          currentFilter: '',
        },
      };
    }

    case PRODUCT_MENU_SET_SUB_FILTER_OPTIONS: {
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.payload.filter]: {
            ...state.filters[action.payload.filter],
            subFilter: {
              ...state.filters[action.payload.filter].subFilter,
              options: action.payload.options,
            },
          },
        },
      };
    }

    default:
      return state;
  }
};
